<template>
  <div>client_events_tasks</div>
</template>

<script>
export default {
  name: "client_events_tasks"
}
</script>

<style scoped>

</style>
